import ArrowForward from '@mui/icons-material/ArrowForward';

import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

import { BASE_STYLES } from '../utils/constants';

export const PoweredByVeloRoot = superstyled({
  name: 'PoweredByVelo',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.spacing(3)
  })
});

export const BusinessResultsBanner = superstyled({
  name: 'PoweredByVelo',
  slot: 'PoweredByVeloBanner',
  tag: Box,
  styles: ({ theme }) => ({
    ...BASE_STYLES,
    display: 'grid',
    gridTemplateColumns: '4fr 3fr',
    gap: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      alignItems: 'center',
      justifyContent: 'center',
      border: `1px solid ${theme.palette.border.main}`,
      borderRadius: theme.shape.borderRadius,
      overflow: 'hidden'
    }
  })
});

export const BusinessResultsBannerText = superstyled({
  name: 'PoweredByVelo',
  slot: 'PoweredByVeloBannerText',
  tag: Text,
  styles: ({ theme }) => ({
    textAlign: 'left',
    padding: theme.spacing(2, 2.5)
  })
});

export const PoweredByVeloImage = superstyled({
  name: 'PoweredByVelo',
  slot: 'PoweredByVeloImage',
  tag: SharedAsset,
  styles: () => ({
    width: '100%',
    height: '100%'
  })
});

export const PoweredByVeloLogoImage = superstyled({
  name: 'PoweredByVelo',
  slot: 'PoweredByVeloLogoImage',
  tag: SharedAsset,
  styles: ({ theme }) => ({
    height: '14px',
    marginRight: theme.spacing(1),
    alignSelf: 'end',
    [theme.breakpoints.down('sm')]: {
      alignSelf: 'center'
    }
  })
});

export const PoweredByVeloButton = superstyled({
  name: 'PoweredByVelo',
  slot: 'PoweredByVeloButton',
  tag: Button,
  styles: ({ theme }) => ({
    position: 'absolute',
    right: '5%',
    bottom: '40%',
    [theme.breakpoints.down('sm')]: {
      bottom: '20%'
    }
  })
});

export const ArrowForwardIcon = superstyled({
  name: 'PoweredByVelo',
  slot: 'ArrowForwardIcon',
  tag: ArrowForward,
  styles: ({ theme }) => ({
    marginLeft: theme.spacing(0.5),
    color: theme.palette.primary.main,
    transition: 'transform 0.3s ease',
    '.MuiButton-root:hover &': {
      transform: 'translateX(6px)'
    }
  })
});
